import Tires from './Tires';

export default function Register() {
  return <Tires viewOnly="cash" />;
}
